import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import FileLayout from '../../Layouts/FileLayout';

import { faDownload, faShare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ProductTitle from '../../Components/Files/ProductTitle';

function App() {
    const [image, setImage] = useState({});
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const { slug, id } = useParams();
    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchImage = async () => {
            let redirected = false;

            try {
                const response = await fetch(`${baseUrl}/arquivos/${slug}/imagens/${id}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (!response.ok) {
                    if (response.status === 404) {
                        navigate('/erro/404', {
                            state: { message: { type: '404', text: 'Arquivo não encontrado!' } },
                        });
                        redirected = true;
                        return;
                    } else if (response.status === 403) {
                        navigate('/erro/403', {
                            state: { message: { type: '403', text: 'Você não tem permissão para acessar essa página.' } },
                        });
                        redirected = true;
                        return;
                    }

                    throw new Error('Erro ao buscar a imagem.');
                }

                const data = await response.json();
                setImage(data.imagem);
            } catch (error) {
                console.error('Erro na requisição de conteúdo', error);
            } finally {
                if (!redirected) {
                    setLoading(false);
                }
            }
        };

        fetchImage();
    }, []);

    useEffect(() => {
        if (!image) return;

        console.log(image);

        const updateViews = async () => {
            try {
                const response = await fetch(`${baseUrl}/arquivos/${image.produto_slug}/visualizar/imagem/${image.id}`, {
                    method: 'PUT',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (!response.ok) {
                    throw new Error('Erro ao atualizar progresso.');
                }
            } catch (error) {
                console.error('Erro na requisição de conteúdo', error);
            }
        };

        updateViews();
    }, [image]);

    const handleDownload = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${baseUrl}/arquivos/${image.produto_slug}/imagens/${image.id}/download`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (!response.ok) {
                throw new Error(`Erro ao baixar arquivo: ${response.statusText}`);
            }

            const blob = await response.blob();

            let fileName = image.nome;
            const contentDisposition = response.headers.get('Content-Disposition');

            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?([^"]+)"?/);
                if (match && match[1]) {
                    fileName = match[1];
                }
            }

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();

            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Erro na requisição:', error);
        }
    };

    const handleShare = async () => {
        const shareUrl = `${window.location.origin}/arquivos/${image.produto_slug}/imagens/${image.id}`;
        const shareText = `Veja essa imagem da Rometal: ${image.nome}`;

        if (navigator.share) {
            try {
                await navigator.share({
                    title: 'Compartilhar',
                    text: shareText,
                    url: shareUrl,
                });
            } catch (error) {
                console.error('Erro ao compartilhar:', error);
            }
        } else {
            alert('O compartilhamento não é suportado neste navegador.');
        }
    };

    if (loading)
        return (
            <div className="mx-auto py-20 flex justify-center">
                <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent"></div>
            </div>
        );

    return (
        <FileLayout>
            <div className="pb-4 md:pb-6 2xl:pb-10">
                <div className="grid grid-cols-12 gap-4 md:gap-6">
                    <div className="col-span-12">
                        <ProductTitle
                            productName={image.nome}
                            loading={loading}
                            breadcrumb={[
                                { label: image.produto_nome, link: `/painel/produtos/${slug}` },
                                { label: 'Imagems', link: `/painel/produtos/${slug}/images` },
                            ]}
                        />

                        <div className="flex flex-col items-center -mb-10">
                            <img src={image.preview} className="rounded-xl border border-neutral-500 mb-4" loading="lazy" />

                            <div className="flex gap-4 mt-3 mb-20">
                                {image.baixavel && (
                                    <button
                                        className="group flex items-center border-2 border-secondary rounded-md text-white font-semibold uppercase tracking-wide px-4 py-2 transition-all hover:bg-secondary"
                                        onClick={handleDownload}
                                    >
                                        <FontAwesomeIcon
                                            icon={faDownload}
                                            className="mr-2 text-secondary transition-all group-hover:text-white"
                                        />
                                        Download
                                    </button>
                                )}
                                {image.compartilhavel && (
                                    <button
                                        className="group flex items-center border-2 border-secondary rounded-md text-white font-semibold uppercase tracking-wide px-4 py-2 transition-all hover:bg-secondary"
                                        onClick={handleShare}
                                    >
                                        <FontAwesomeIcon
                                            icon={faShare}
                                            className="mr-2 text-secondary transition-all group-hover:text-white"
                                        />
                                        Compartilhar
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </FileLayout>
    );
}

export default App;
